import Dashboard from "@/common/components/layout/Dashboard";
import { ToastProvider } from "@/common/components/ui/toast/toast.provider";
import RescissionDetails from "./components/RescissionDetails";
import { RenterDashboardProvider } from "../renter-dashboard/RenterDashboard.provider";
import { useParams } from "react-router-dom";
import Toast from "@/common/components/ui/toast";


function RescissionDetailsPages() {
  const { renterId } = useParams()
  return (
    <ToastProvider>
      <Dashboard>
        <RenterDashboardProvider renterId={renterId || ''}>
          <RescissionDetails />
        </RenterDashboardProvider>
        <Toast />
      </Dashboard>
    </ToastProvider>
  )
}

export default RescissionDetailsPages